/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Male_Pink_Warbler_EditInputs */

const fr_male_pink_warbler_edit = /** @type {(inputs: Male_Pink_Warbler_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image de profil`)
};

/**

* @param {Male_Pink_Warbler_EditInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const male_pink_warbler_edit = /** @type {((inputs?: Male_Pink_Warbler_EditInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Male_Pink_Warbler_EditInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_male_pink_warbler_edit(inputs)
});